export const XXXLARGE = 1675;
export const XXLARGE = 1420;
export const XLARGE = 1192;
export const LARGE = 992;
export const MEDIUM = 768;
export const SMALL = 640;
export const XSMALL = 415;
export const MIN = 0;
export function isMinimumBreakpoint(newWidth, breakpoint) {
    return newWidth >= breakpoint;
}
export function isMin(newWidth) {
    return isMinimumBreakpoint(newWidth, MIN);
}
export function isXSmall(newWidth) {
    return isMinimumBreakpoint(newWidth, XSMALL);
}
export function isSmall(newWidth) {
    return isMinimumBreakpoint(newWidth, SMALL);
}
export function isMedium(newWidth) {
    return isMinimumBreakpoint(newWidth, MEDIUM);
}
export function isLarge(newWidth) {
    return isMinimumBreakpoint(newWidth, LARGE);
}
export function isXLarge(newWidth) {
    return isMinimumBreakpoint(newWidth, XLARGE);
}
export function isXXLarge(newWidth) {
    return isMinimumBreakpoint(newWidth, XXLARGE);
}
export function isXXXLarge(newWidth) {
    return isMinimumBreakpoint(newWidth, XXXLARGE);
}
export function getBreakpointName() {
    if (global?.innerWidth) {
        if (isXXXLarge(global.innerWidth)) {
            return 'xxxlarge';
        }
        if (isXXLarge(global.innerWidth)) {
            return 'xxlarge';
        }
        if (isXLarge(global.innerWidth)) {
            return 'xlarge';
        }
        if (isLarge(global.innerWidth)) {
            return 'large';
        }
        if (isMedium(global.innerWidth)) {
            return 'medium';
        }
        if (isSmall(global.innerWidth)) {
            return 'small';
        }
        if (isXSmall(global.innerWidth)) {
            return 'xsmall';
        }
        return 'min';
    }
    return undefined;
}
